import {RouteObject} from 'react-router-dom';
import React from 'react';
import PermissionMana from '@pages/front/pages/permission/PermissionMana';
import LazyWrapper from '@/common/LasyWrapper';

const MemberMana = React.lazy(() => import('./member/MemberMana'));
const PermissionTree = React.lazy(() => import('./PermissionTree'));

const router: RouteObject[] = [
  {
    path: 'permission',
    element: <PermissionMana></PermissionMana>
  },
  {
    path: 'permission/permissionMember',
    element: <LazyWrapper><MemberMana></MemberMana></LazyWrapper>
  },
  {
    path: 'permission/addPerTree',
    element: <LazyWrapper><PermissionTree></PermissionTree></LazyWrapper>
  },
  {
    path: 'permission/editPerTree',
    element: <LazyWrapper><PermissionTree></PermissionTree></LazyWrapper>
  }
];
export default router;
